import { bodyAreaGroups, getArea } from "@/content";

export default function AreaChips({ active, onSelect, idPrefix = "body-chip" }) {
  return (
    <div className="space-y-6">
      {bodyAreaGroups.map((g) => (
        <fieldset key={g.id}>
          <legend className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-muted">{g.label}</legend>
          <div className="flex flex-wrap gap-2">
            {g.areas.map((slug) => {
              const a = getArea(slug);
              const isActive = active === slug;
              return (
                <button
                  key={slug}
                  type="button"
                  onClick={() => onSelect(slug)}
                  aria-pressed={isActive}
                  data-testid={`${idPrefix}-${slug}`}
                  className={`chip ${isActive ? "is-active" : ""}`}
                >
                  {a.label}
                </button>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
